<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#27AE60"/>
    <path d="M6.3418 16.8414L4.3418 16.8414C3.45442 13.8163 3.40851 12.0909 4.3418 8.84143L6.3418 8.84143C5.44946 12.0156 5.51879 13.7872 6.3418 16.8414ZM16.3518 11.8414L8.3418 11.8414L8.3418 13.8414L16.3518 13.8414L16.3518 16.8414L20.3418 12.8414L16.3518 8.84143L16.3518 11.8414Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "NivelBaixo"
}
</script>

<style scoped>

</style>
